export const AFFILIATED_TRAINER_BASE = 'trainer/AFFILIATED_TRAINER_BASE'
export const AFFILIATED_TRAINER_LOADING = 'trainer/AFFILIATED_TRAINER_LOADING'
export const AFFILIATED_TRAINER_SUCCESS = 'trainer/AFFILIATED_TRAINER_SUCCESS'